import _toConsumableArray from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.find-index.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import { cloneDeep, find } from 'lodash';
import { dialog } from 'src/boot/mixins.js';
import listableUsersFromIntegration from 'src/components/Dialogs/ListableUsersFromIntegration';
import integration from 'src/mixins/integration';
export default {
  mixins: [dialog, integration],
  name: 'InviteUsersFromIntegration',
  components: {
    TeDialog: TeDialog,
    listableUsersFromIntegration: listableUsersFromIntegration
  },
  props: {
    providers: {
      default: function _default() {
        return [{
          integrationCode: 'microsoft',
          isConfigured: false
        }, {
          integrationCode: 'googleworkspace',
          isConfigured: false
        }];
      }
    },
    provider: {
      default: ''
    },
    excludedUsers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    onComplete: {
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      myProviders: cloneDeep(this.providers),
      users: [],
      selectedUsers: [],
      textFilter: '',
      nextLink: null,
      serverSidePagination: false
    };
  },
  computed: {
    allSelected: {
      get: function get() {
        return this.selectableUsers.length === this.selectedUsers.length && this.selectedUsers.length > 0;
      },
      set: function set(val) {
        var _this = this;

        if (val) {
          this.selectableUsers.forEach(function (user) {
            if (_this.selectedUsers.includes(user)) {
              return;
            }

            _this.toggleUserSelected(user);
          });
        } else {
          this.selectedUsers = [];
        }
      }
    },
    selectableUsers: function selectableUsers() {
      return this.listableUsers.filter(function (user) {
        return !(user.isMember || user.isRegistered);
      });
    },
    listableUsers: function listableUsers() {
      if (this.serverSidePagination) {
        return this.users;
      } else {
        return this.filteredUsers;
      }
    },
    filteredUsers: function filteredUsers() {
      var _this2 = this;

      if (!this.textFilter) return this.users;
      return this.users.filter(function (user) {
        return user.name.toLowerCase().replace(/ /g, '').indexOf(_this2.textFilter.toLowerCase().replace(/ /g, '')) >= 0 || user.email.toLowerCase().replace(/ /g, '').indexOf(_this2.textFilter.toLowerCase().replace(/ /g, '')) >= 0 || user.department && user.department.toLowerCase().replace(/ /g, '').indexOf(_this2.textFilter.toLowerCase().replace(/ /g, '')) >= 0;
      });
    },
    selectedProvider: function selectedProvider() {
      return find(this.myProviders, {
        integrationCode: this.provider
      });
    },
    providerName: function providerName() {
      var serviceText = '';

      switch (this.provider) {
        case 'microsoft':
          serviceText = 'Microsoft';
          break;

        case 'googleworkspace':
          serviceText = 'Google Workspace';
          break;
      }

      return serviceText;
    }
  },
  methods: {
    onLinkIntegration: function onLinkIntegration(integration) {
      var _this3 = this;

      if (integration.pivot) {
        var myIntegration = find(this.myProviders, {
          integrationCode: integration.integration_code
        });

        if (myIntegration) {
          myIntegration.isConfigured = true;
          this.loadUsers().catch(function (error) {
            _this3.selectedProvider.isConfigured = false;

            if (error.response.status !== 422) {
              _this3.$q.notify({
                type: 'negative',
                message: _this3.$t('components.inviteUsersFromIntegrationDialog.something_went_wrong_retrieving_users')
              });
            }
          });
        }
      }
    },
    unlinkIntegration: function unlinkIntegration() {
      var _this4 = this;

      this.unlink(this.provider).then(function () {
        _this4.selectedProvider.isConfigured = false;
        _this4.users = [];
      });
    },
    loadUsers: function loadUsers() {
      var _this5 = this;

      var append = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.showLoading(this.$t('components.inviteUsersFromIntegrationDialog.retrieving_users'));
      var url = "/integrations/".concat(this.provider, "/users?per_page=100").concat(this.nextLink ? '&next_link=' + encodeURIComponent(this.nextLink) : '').concat(this.textFilter ? '&query=' + this.textFilter : '');
      return this.$axios.get(url).then(function (response) {
        var users = response.data.users ? response.data.users : response.data;
        users.map(function (user) {
          user.mode = _this5.provider;
          return user;
        });

        if (append) {
          _this5.users = [].concat(_toConsumableArray(_this5.users), _toConsumableArray(users));
        } else {
          _this5.users = users;
        }

        if (response.data.next_link) {
          _this5.nextLink = response.data.next_link;
          _this5.serverSidePagination = true; // this will be set on the first load and stay true for the rest of the time
        } else {
          _this5.nextLink = null;
        }
      }).finally(function () {
        _this5.hideLoading();
      });
    },
    loadAccountIntegration: function loadAccountIntegration() {
      var _this6 = this;

      this.showLoading(this.$t('general.loading_integration'));
      this.loadIntegration(this.provider).then(function (response) {
        _this6.onLinkIntegration(response.data);
      });
    },
    toggleUserSelected: function toggleUserSelected(user) {
      if (user.isMember || user.isRegistered) return; // Check if the user is already in the selectedUsers array

      var index = this.selectedUsers.findIndex(function (selectedUser) {
        return selectedUser.email === user.email;
      });

      if (index === -1) {
        this.selectedUsers.push(user);
      } else {
        this.selectedUsers.splice(index, 1);
      }
    },
    inviteUsersByEmail: function inviteUsersByEmail() {
      this.openDialog('InviteUsersDialog', {
        importedUsers: this.selectedUsers.map(function (user) {
          return {
            id: user.id,
            email: user.email,
            name: user.name,
            mode: user.mode,
            selected: false,
            workspace_access_level: 'member',
            // default access level
            add_to: 'project',
            // default add to
            group_id: null,
            project_ids: []
          };
        }),
        onInvite: this.onComplete
      });
    }
  },
  mounted: function mounted() {
    if (this.provider) {
      this.loadAccountIntegration();
    }
  }
};